import { useEffect } from 'react';
import { Flex } from '@chakra-ui/react';
import { useInstanceError, useSocketInstance } from './api/init';
import Login from './components/login/Login';
import Navbar from './components/layout/Navbar';
import Main from './components/layout/Main';
import { useSelector } from 'react-redux';
import { TState, useActions } from './redux/store';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

import './App.css';
import './index.css';

type TResponse = { success: boolean; token: string; data: any };

const findElement = (el: Element, selector: string) => {
  if (el.parentElement?.querySelector(selector)) {
    (el.parentElement?.querySelector(selector) as HTMLButtonElement)?.click();
  } else if (el.parentElement) {
    findElement(el.parentElement, selector);
  }
};

const App = () => {
  useInstanceError();
  useSocketInstance();

  const user = useSelector((state: TState) => state.user);
  const token = useSelector((state: TState) => state.token);
  const isMobile = useSelector((state: TState) => state.isMobile);
  const isTablet = useSelector((state: TState) => state.isTablet);
  const theme = useSelector((state: TState) => state.theme);
  const isPlanning = useSelector(
    (state: TState) => state.currentTab?.isPlanning,
  );

  const { setToken, setLogin } = useActions();

  const handleLogin = (resp: TResponse) => {
    if (!resp?.success) return;
    setToken(resp.token);
    setLogin('');
  };

  useEffect(() => {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && document.activeElement) {
        findElement(document.activeElement, '.submit');
      }
    });
  }, []);

  const displayLogin = !token || user.tempPasswordForced || user.tempPassword;

  useEffect(() => {
    if (!displayLogin) {
      navigator.serviceWorker.register('/sw.js');
    }
  }, [displayLogin]);

  return (
    <>
      {displayLogin ? (
        <Flex direction='column' w='100%'>
          <Login handleLogin={handleLogin} />
        </Flex>
      ) : (
        <Flex
          bgColor={'gray.100'}
          bgGradient={
            isPlanning ? '' : `linear(to-r, ${theme.light}, ${theme.normal})`
          }
          overflow='hidden'
          transform={isMobile || isTablet ? 'scale(0.8)' : ''}
          transformOrigin='top left'
          w={isMobile || isTablet ? '125%' : ''}
          h={isMobile || isTablet ? '125%' : ''}
          maxH={isMobile || isTablet ? '125%' : ''}
        >
          <Navbar />
          <Main />
        </Flex>
      )}
      {/* <Button
        onClick={() => {
          socketInstance?.emit('click', {
            token: user._id,
            selector: '.ifr-call-button',
          });
        }}
      >
        Décrocher
      </Button>
      <Button
        onClick={() => {
          socketInstance?.emit('click', {
            token: user._id,
            selector: '.cc-button-control_hangup',
          });
        }}
      >
        Racrocher
      </Button> */}
      {/* <iframe
        width='600'
        height='600'
        loading='lazy'
        allow='microphone; speaker-selection; autoplay; camera; display-capture; hid'
        sandbox='allow-popups allow-scripts allow-same-origin'
        src={`${
          import.meta.env.VITE_BASE_URL
        }/api/proxy?bearer=${encodeURIComponent(
          token,
        )}&company=${localStorage.getItem('company')}`}
        // src='/api/proxy'
      ></iframe> */}
    </>
  );
};

export default App;
